<template>
    <div class="emoji-c">
        <img class="triangle" src="../../images/top-v.png">
        <EmojiList :articleId="articleId" @clickEmoji="handleEmoji"></EmojiList>
    </div>
</template>
<script>
import { default as EmojiList } from 'common-components/lib/emojiList/index'
import 'common-components/lib/emojiList/index.css'

export default{
    name: 'emoji',
    components: {
        EmojiList
    },
    computed: {
       articleId() {
           return window.pcArticleInfo?.news_id
       }
    },
    mounted() {
        document.querySelector('body').addEventListener('click',()=>{
            this.handleEmoji() // 关闭表情弹窗
        })
    },
    data(){
        return {
            
        }
    },
    methods: {
        handleEmoji(emoji) {
            this.$emit('chooseEmoji',emoji)
        }
    }

}
</script>
<style lang="less" scoped>
.emoji-c {
    .triangle {
        position: absolute;
        bottom: -1px;
        left: 13px;
        width: 13px;
        height: 7px;
        z-index: 2;
    }
    /deep/ .emoji-list-container{
        cursor: pointer;
        position: absolute;
        top: 36px;
        left: 0;
        background-color: #fff;
        border-radius: 6px;
        width:324px;
        padding: 6px 10px 8px 8px;
        z-index: 1;
        box-sizing: border-box;
        box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.17);
        .emoji-reprint{
            position: absolute;
            z-index: 1;
            bottom: 12px;
            right: 12px;
            .reprint-text{
                margin-right: 0;
            }
        }
        .emoji-list{
            display: grid;
            grid-template-columns: repeat(auto-fill, 26px);
            grid-auto-rows: 26px;
            gap: 8px 14px;
            .emoji-item{
                width: 26px;
                height: 26px;
                cursor: pointer;
                line-height: 26px;
                font-size: 21px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
</style>
